/** @jsxImportSource @emotion/react */

import { createRef, Component } from 'react';
import { css } from '@emotion/react';

import { imgObserver } from '@utils/customLib';

class CLazyImg extends Component {
	constructor(props) {
		super(props);
		this.$imgRef = createRef();
		this.state = {
			setSrc: false,
		};
	}

	componentDidMount() {
		const { rootselector } = this.props;

		this.imgObserve = imgObserver(
			this.$imgRef.current,
			rootselector,
			this.setSrc
		);
	}

	componentWillUnmount() {
		this.imgObserve.destroy();
	}

	setSrc = () => {
		this.setState({
			setSrc: true,
		});
	};

	render() {
		const { setSrc } = this.state;
		const { alt, src, className, height, width, ...childprops } =
			this.props;

		return (
			<div
				css={css`
					width: ${width > 320 ? '100%' : `${width}px`};
				}`}
				className={`max-w-full ${className || ''}`}
			>
				<div
					className="aspect-ratio-box"
					css={css`
						padding-top: ${(height * 100) / width}%;
					`}
				>
					<img
						ref={this.$imgRef}
						alt={alt}
						src={
							setSrc
								? src
								: 'https://bitbns.com/assets/img/logos/bns.png'
						}
						data-src={setSrc ? false : src}
						className="aspect-ratio-contents"
						height={height}
						width={width}
						{...childprops}
					/>
				</div>
			</div>
		);
	}
}

export default CLazyImg;
